<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <h1 class="modal-title">Order Successfully Processed</h1>
      <p class="modal-description">
        Your order has been successfully processed. You can now print your tickets or review
        your order details.
      </p>
      <div class="buttons">
        <main-button outline @click="$emit('viewOrder')">View order</main-button>
        <main-button @click="$emit('printTickets')">
          <v-icon color="white" style="margin-right: 0.5rem">print</v-icon>
          Print tickets
        </main-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'successful-payment-modal',
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}

.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 40.75rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.modal::-webkit-scrollbar {
  display: none;
}

.modal-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 2rem;
}

@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}

.modal-description {
  margin: 0;
  color: #979797;
  font-family: "Source Sans Pro";
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 3.5rem;
}
</style>
